export default __webpack_public_path__ + "static/media/zm.2d02ca9d.svg";